(() => {
  const elementName = 'footer-monthly-countdown';

  if (customElements.get(elementName)) {
    return;
  }

  customElements.define(
    elementName,
    class FooterMonthlyCountdown extends HTMLElement {
      connectedCallback() {
        window.clearInterval(this.interval);
        window.cancelAnimationFrame(this.frame);

        this.targetDay = this.readNumber('targetDay', 15);
        this.targetHour = this.readNumber('targetHour', 23);
        this.targetMinute = this.readNumber('targetMinute', 59);
        this.leadingZero = this.hasAttribute('data-leading-zero');

        this.cacheElements();
        this.update();
        this.frame = window.requestAnimationFrame(() => {
          this.cacheElements();
          this.update();
        });
        this.interval = window.setInterval(() => this.update(), 1000);
      }

      disconnectedCallback() {
        window.clearInterval(this.interval);
        window.cancelAnimationFrame(this.frame);
      }

      readNumber(key, fallback) {
        const value = this.dataset[key];
        const number = Number(value);

        return value !== undefined && value !== '' && Number.isFinite(number) ? number : fallback;
      }

      cacheElements() {
        this.days = this.days || this.querySelector('[data-countdown-days]');
        this.hours = this.hours || this.querySelector('[data-countdown-hours]');
        this.minutes = this.minutes || this.querySelector('[data-countdown-minutes]');
        this.seconds = this.seconds || this.querySelector('[data-countdown-seconds]');
        this.summary = this.summary || this.querySelector('[data-countdown-summary]');
      }

      getTargetDate(now) {
        let year = now.getFullYear();
        let month = now.getMonth();
        let target = this.buildDate(year, month);

        if (now.getTime() > target.getTime()) {
          month += 1;

          if (month > 11) {
            month = 0;
            year += 1;
          }

          target = this.buildDate(year, month);
        }

        return target;
      }

      buildDate(year, month) {
        const lastDay = new Date(year, month + 1, 0).getDate();
        const day = Math.min(Math.max(this.targetDay, 1), lastDay);
        const hour = Math.min(Math.max(this.targetHour, 0), 23);
        const minute = Math.min(Math.max(this.targetMinute, 0), 59);

        return new Date(year, month, day, hour, minute, 59, 999);
      }

      update() {
        this.cacheElements();

        const now = new Date();
        const target = this.getTargetDate(now);
        const difference = Math.max(target.getTime() - now.getTime(), 0);
        const totalSeconds = Math.floor(difference / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        this.setValue(this.days, days);
        this.setValue(this.hours, hours);
        this.setValue(this.minutes, minutes);
        this.setValue(this.seconds, seconds);

        if (this.summary) {
          this.summary.setAttribute(
            'aria-label',
            `${days} days, ${hours} hours, ${minutes} minutes, ${seconds} seconds until the next enrollment date`
          );
        }
      }

      setValue(element, value) {
        if (!element) {
          return;
        }

        element.textContent = this.leadingZero ? String(value).padStart(2, '0') : String(value);
      }
    }
  );
})();
